import { render, staticRenderFns } from "./FreightDetail.vue?vue&type=template&id=478a2ac4&scoped=true&"
import script from "./FreightDetail.vue?vue&type=script&lang=js&"
export * from "./FreightDetail.vue?vue&type=script&lang=js&"
import style0 from "./FreightDetail.vue?vue&type=style&index=0&id=478a2ac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a2ac4",
  null
  
)

export default component.exports